export type ReactiveFormSubmitNavigationDecisionAction = 'goBack' | 'stay';

export interface ReactiveFormSubmitNavigationDecisionOptions {
  readonly shouldNavigateBack?: boolean;
  readonly reason?: string;
}

export interface ReactiveFormSubmitNavigationDecisionSnapshot {
  readonly action: ReactiveFormSubmitNavigationDecisionAction;
  readonly shouldNavigateBack: boolean;
  readonly reason?: string;
}

/** Builds immutable navigation decisions for successful submit completion. */
export class ReactiveFormSubmitNavigationDecision {
  public static resolve(
    options: ReactiveFormSubmitNavigationDecisionOptions = {},
  ): ReactiveFormSubmitNavigationDecisionSnapshot {
    return options.shouldNavigateBack === false
      ? ReactiveFormSubmitNavigationDecision.stay(options.reason)
      : ReactiveFormSubmitNavigationDecision.goBack(options.reason);
  }

  public static goBack(
    reason?: string,
  ): ReactiveFormSubmitNavigationDecisionSnapshot {
    return ReactiveFormSubmitNavigationDecision.create('goBack', true, reason);
  }

  public static stay(
    reason?: string,
  ): ReactiveFormSubmitNavigationDecisionSnapshot {
    return ReactiveFormSubmitNavigationDecision.create('stay', false, reason);
  }

  private static create(
    action: ReactiveFormSubmitNavigationDecisionAction,
    shouldNavigateBack: boolean,
    reason?: string,
  ): ReactiveFormSubmitNavigationDecisionSnapshot {
    if (reason === undefined) {
      return { action, shouldNavigateBack };
    }

    return { action, shouldNavigateBack, reason };
  }
}
